import {ILeaderboardTeamItem} from '@/types/ws.types'
import {useGSAP} from '@gsap/react'
import {
  ESprintenTeam,
  SprintenTeamsLogoMap,
} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'
import clsx from 'clsx'
import gsap from 'gsap'
import {FC, useRef} from 'react'

export interface ISlotData extends ILeaderboardTeamItem {
  position: number
}

interface IMapItemProps {
  slotData: ISlotData
}

export const MapItem: FC<IMapItemProps> = ({slotData}) => {
  const itemRef = useRef<HTMLDivElement>(null)

  const {percentage, team, position} = slotData

  useGSAP(
    () => {
      gsap.to(itemRef.current, {
        top: `${100 - (percentage ?? 0)}%`,
        ease: 'linear',
      })
    },
    {
      dependencies: [percentage],
    },
  )

  return (
    <div ref={itemRef} className="pointer-events-auto absolute top-full size-[1px]">
      <div
        className={clsx(
          'flex origin-center -translate-x-[50%] -translate-y-[50%] items-center justify-center overflow-hidden border-white transition-all',
          position === 1 && 'z-50 size-[64px] rounded-[16px] border-[4px]',
          position === 2 && 'z-40 size-[48px] rounded-[12px] border-[3px]',
          position === 3 && 'z-30 size-[48px] rounded-[12px] border-[3px]',
          position === 4 && 'z-20 size-[48px] rounded-[12px] border-[3px]',
          position === 5 && 'z-10 size-[48px] rounded-[12px] border-[3px]',
          team === ESprintenTeam.Anglamark && 'bg-team-anglamark',
          team === ESprintenTeam.CoopMega && 'bg-team-coop_mega',
          team === ESprintenTeam.CoopPrix && 'bg-team-coop_prix',
          team === ESprintenTeam.Extra && 'bg-team-extra',
          team === ESprintenTeam.OBS && 'bg-team-obs',
        )}
      >
        <img src={SprintenTeamsLogoMap[team]} alt={team} className="size-full" />
      </div>
    </div>
  )
}
